module.exports = __webpack_public_path__ + "img/Flag_of_Zambia.6f7c7ff3.svg";